<template>
    <Header
        :page-title="title"
    ></Header>
    <pageTool></pageTool>
    <div class="page-content cus-content">
        <businessNav
            :nav-data="navData"
            @navClick="navClick"
        ></businessNav>
        <div class="page-content-text" v-if="apiData.index == 0">
            <div class="page-content-text-title">{{ apiData.title }}</div>
            <div class="page-content-text-text" v-html="apiData.text"></div>
        </div>
        <div class="page-content-img" v-else-if="apiData.index == 1">
            <img v-for="(img, i) in apiData.imgs" :src="apiData.internalInstance.appContext.config.globalProperties.$imgUrl + img" :key="i">
        </div>
        <div v-else-if="apiData.index == 2">
            <div class="page-content-html">
                <div v-html="apiData.domData"></div>
                <div v-if="apiData.resources.length > 0">
                    <div class="file-download" v-for="(item, i) in apiData.resources" :key="i">
                        <div>附件{{ i+1 }}：{{ item.title }}</div>
                        <a :href="apiData.internalInstance.appContext.config.globalProperties.$imgUrl + item.url">下载文件</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Header from "@/components/SNInfo/Header"
import businessNav from "@/components/nav/businessNav"
import pageTool from "@/components/nav/pageTool"
import {getCurrentInstance, onMounted, reactive} from "@vue/runtime-dom"
import {getProcessDetail} from "@/api/policy"
import {useRoute} from "vue-router";
const banner = require('@/assets/img/page_banner_1.png')
const businessIcon0 = require('@/assets/img/business_1.png')
const businessIcon1 = require('@/assets/img/business_2.png')
const businessIcon2 = require('@/assets/img/business_0.png')
export default {
    name: "PCP",
    setup() {
        const route = useRoute()
        const title = reactive({
            cn: '农业保险',
            en: 'AGRICULTURAL INSURANCE',
            hasSearch: false,
            titleStyle: false,
            banner
        })
        const apiData = reactive({
            title: '',
            text: '',
            imgs: [],
            index: 0,
            internalInstance: getCurrentInstance(),
            domData: '',
            resources: ''
        })
        const navData = reactive({
            menuNames: [{name: '业务介绍', icon: businessIcon0}, {name: '业务流程', icon: businessIcon1}, {name: '业务办理', icon: businessIcon2}],
            activeName: '业务介绍'
        })
        const nameIndex = {'业务介绍': 0,'业务流程': 1,'业务办理': 2}
        const navClick = (name) => {
            navData.activeName = name
            apiData.index = nameIndex[name]
        }
        const init = async (params) => {
            const data = await getProcessDetail(params)
            apiData.title = data.title
            apiData.text = data.text
            apiData.imgs = data.imgs ? data.imgs.split(',') : ''
            apiData.domData = data.process
            apiData.resources = data.resources
        }
        onMounted(() => {
            if (route.query.params == '200022&1372795182163951616') {
                title.cn = '产权证办理'
                title.en = 'PRODUCT CERTIFICATE PROCESSING'
            }
            init(route.query.params)
        })
        return {
            title,
            navData,
            apiData,
            navClick
        }
    },
    components: {
        Header,
        businessNav,
        pageTool
    }
}
</script>

<style scoped lang="stylus">
.page-content {
    padding 20px 30px
    .page-content-text {
        margin-top 15px
        width 100%
        .page-content-text-title {
            width 100%
            font-size 16px
            color #6A6A6A
            font-weight bolder
        }
    }
    .page-content-img {
        margin-top 15px
        width 100%
        overflow hidden
    }
    .page-content-img img {
        width 100%
    }
    .page-block {
        .li-header {
            margin-top 20px
        }
    }
}
.page-img {
    width 100%
    padding 20px
}
.page-img img {
    width 100%
}
</style>